import { createContext, useContext, type PropsWithChildren } from "react";

import type { IntegratorSubappKey } from "@hub-modules";

const HubModuleKeyContext = createContext<IntegratorSubappKey | null>(null);

/** Set by {@link Layout} so tab metadata can use the active integrator module key. */
export function HubModuleKeyProvider({
  moduleKey,
  children,
}: PropsWithChildren<{ moduleKey: IntegratorSubappKey }>): JSX.Element {
  return <HubModuleKeyContext.Provider value={moduleKey}>{children}</HubModuleKeyContext.Provider>;
}

export function useHubModuleKey(): IntegratorSubappKey | null {
  return useContext(HubModuleKeyContext);
}
